"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_string_1 = __importDefault(require("./is-string"));
const is_number_1 = __importDefault(require("./is-number"));
const is_bigint_1 = __importDefault(require("./is-bigint"));
const is_boolean_1 = __importDefault(require("./is-boolean"));
const is_symbol_1 = __importDefault(require("./is-symbol"));
const is_undefined_1 = __importDefault(require("./is-undefined"));
const is_null_1 = __importDefault(require("./is-null"));
function isPrimitive(value) {
    return ((0, is_string_1.default)(value) ||
        (0, is_number_1.default)(value) ||
        (0, is_bigint_1.default)(value) ||
        (0, is_boolean_1.default)(value) ||
        (0, is_symbol_1.default)(value) ||
        (0, is_undefined_1.default)(value) ||
        (0, is_null_1.default)(value));
}
exports.default = isPrimitive;
//# sourceMappingURL=is-primitive.js.map